import React, { useState } from 'react';
import classNames from 'classnames';
import classes from './index.module.scss';
import { CollapsibleProps } from './types';
import { CollapsibleContext } from './CollapsibleContext';

const Collapsible = ({
  defaultExpanded = false,
  expanded: controlledExpanded,
  onToggle = () => undefined,
  disabled,
  children,
}: CollapsibleProps) => {
  const [innerExpanded, setInnerExpanded] = useState(defaultExpanded);
  const expanded = controlledExpanded === undefined ? innerExpanded : controlledExpanded;

  const toggleExpanded = () => {
    if (disabled) {
      return;
    }

    onToggle(!expanded);
    setInnerExpanded(!expanded);
  };

  const className = classNames(classes.collapsible, {
    [classes.expanded]: expanded,
    [classes.disabled]: disabled,
  });

  return (
    <CollapsibleContext.Provider value={{ expanded, toggleExpanded, disabled }}>
      <article className={className}>{children}</article>
    </CollapsibleContext.Provider>
  );
};

Collapsible.displayName = 'Collapsible';

export default Collapsible;
